type AppConfig = {
  auth: {
    authority: string
    clientId: string
    loginRedirectUri: string
    logoutRedirectUri: string
    apiUrl: string
  }
  api: {
    baseUrl: string
    // websocketUrl: string
    // printerApiUrl: string
    axiosTimeoutMs: number
  }
  //   home: {
  //     // gtsUrl: string
  //     // rmscUrl: string
  //     reportsUrl: string
  //     ecoUrl: string
  //     testHallUrl: string
  //   }
  enableApiMocking: boolean
}

declare global {
  interface Window {
    __ENV__?: {
      VITE_AUTH_AUTHORITY?: string
      VITE_AUTH_CLIENT_ID?: string
      VITE_AUTH_LOGIN_REDIRECT_URI?: string
      VITE_AUTH_LOGOUT_REDIRECT_URI?: string
      VITE_AUTH_API_URL?: string
      VITE_ENABLE_API_MOCKING?: string
      VITE_API_BASE_URL?: string
      //   VITE_WEBSOCKET_URL?: string
      //   VITE_PRINTER_API_URL?: string
      VITE_AXIOS_TIMEOUT_MS?: string
      //   VITE_HOME_GTS_URL?: string
      //   VITE_HOME_RMSC_URL?: string
      //   VITE_HOME_REPORTS_URL?: string
      //   VITE_HOME_ECO_URL?: string
      //   VITE_HOME_TESTHALL_URL?: string
    }
  }
}

type RuntimeEnv = NonNullable<Window['__ENV__']>
type RuntimeEnvKey = keyof RuntimeEnv

/* const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1', '[::1]'])

const getHostnamePrefix = (hostname: string): string => {
  const dotIndex = hostname.indexOf('.')
  return dotIndex === -1 ? '' : hostname.slice(0, dotIndex)
}

const getHostnameSuffix = (hostname: string): string => {
  const dotIndex = hostname.indexOf('.')
  return dotIndex === -1 ? '' : hostname.slice(dotIndex + 1)
} */

/* const resolveCurrentDomainUrl = (urlValue: string): string => {
  const value = urlValue.trim()
  const currentHostname = window.location.hostname

  if (value === '' || LOCAL_HOSTNAMES.has(currentHostname)) {
    return value
  }

  const currentSuffix = getHostnameSuffix(currentHostname)

  if (currentSuffix === '') {
    return value
  }

  // The configured value may carry a Traefik-style regex host, e.g.
  // "https://api-core-foxpro.apps.nvd.local|fii-na.com/ws" — that is NOT a valid URL, so we
  // can't use `new URL()` (it throws "Failed to construct URL"). Keep only the scheme, the
  // service prefix (first hostname label) and the path, then rebuild the domain from the
  // current origin. Works the same for http(s) and ws(s): cut everything from the first dot
  // (i.e. before ".apps...") and splice in the domain the user actually came from.
  const schemeMatch = value.match(/^[a-z][a-z0-9+.-]*:\/\//i)

  if (!schemeMatch) {
    return value
  }

  const scheme = schemeMatch[0]
  const afterScheme = value.slice(scheme.length)
  const pathStart = afterScheme.indexOf('/')
  const hostPart = pathStart === -1 ? afterScheme : afterScheme.slice(0, pathStart)
  const pathPart = pathStart === -1 ? '' : afterScheme.slice(pathStart)
  const prefix = getHostnamePrefix(hostPart)

  if (prefix === '') {
    return value
  }

  return `${scheme}${prefix}.${currentSuffix}${pathPart}`
} */

const get = (key: RuntimeEnvKey): string => window.__ENV__?.[key] ?? (import.meta.env[key] as string) ?? ''
//const getDomainAwareUrl = (key: RuntimeEnvKey): string => resolveCurrentDomainUrl(get(key))
// const getUrl = (key: RuntimeEnvKey, fallback: string): string => {
//   const value = get(key).trim()
//   return value === '' ? fallback : value
// }
const getNumber = (key: RuntimeEnvKey, fallback: number): number => {
  const raw = get(key)
  if (raw === '') {
    return fallback
  }
  const parsed = Number(raw)
  return Number.isFinite(parsed) ? parsed : fallback
}

export const config: AppConfig = {
  auth: {
    // Keycloak is also per-domain (from domain X → X's Keycloak, from Y → Y's), so these are
    // domain-aware: the resolver keeps the host prefix (e.g. "auth") and splices in the current
    // domain. ${KEYCLOAK_HOST} is a clean single host here (no ${DOMAIN} regex), but the
    // string-based resolver would handle a regex value too without throwing.
    authority: get('VITE_AUTH_AUTHORITY'),
    clientId: get('VITE_AUTH_CLIENT_ID'),
    // Redirects must return to the current origin (where the user came from), regardless of domain.
    loginRedirectUri: window.location.origin,
    logoutRedirectUri: window.location.origin,
    apiUrl: get('VITE_AUTH_API_URL'),
  },
  api: {
    baseUrl: get('VITE_API_BASE_URL'),
    // websocketUrl: getDomainAwareUrl('VITE_WEBSOCKET_URL'),
    // printerApiUrl: getDomainAwareUrl('VITE_PRINTER_API_URL'),
    axiosTimeoutMs: getNumber('VITE_AXIOS_TIMEOUT_MS', 15000),
  },
  //   home: {
  //     gtsUrl: getUrl('VITE_HOME_GTS_URL', '/'),
  //     rmscUrl: getUrl('VITE_HOME_RMSC_URL', '/'),
  //     reportsUrl: getUrl('VITE_HOME_REPORTS_URL', '/'),
  //     ecoUrl: getUrl('VITE_HOME_ECO_URL', '/'),
  //     testHallUrl: getUrl('VITE_HOME_TESTHALL_URL', '/'),
  //   },
  enableApiMocking: (window.__ENV__?.VITE_ENABLE_API_MOCKING ?? import.meta.env.VITE_ENABLE_API_MOCKING) === 'true',
}
